/* eslint-disable react/no-array-index-key */
import getCompany from '@streamfields/BonusweltSlider/ApiCalls';
import { Company } from '@streamfields/BonusweltSlider/models';
import React, { useEffect, useState } from 'react';
import NextImage from 'next/image';
import { addBaseUrl } from '@/utils/url';
import { useRouter } from 'next/router';
import Link from 'next/link';
import Head from 'next/head';

export { getStaticProps } from './[...path]';

function BonusweltDetail() {
  const [company, setCompany] = useState<Company | undefined>(undefined);

  const router = useRouter();
  const id = `${router.query.id}`;
  useEffect(() => {
    if (id !== 'undefined') {
      getCompany(id).then(res => {
        if (res) {
          setCompany(res);
        }
      });
    }
  }, [id]);
  return (
    <div className='bonuswelt-detail-page'>
      {company ? (
        <>
          <Head>
            <title>{company.name}</title>
          </Head>

          <div className='container bonuswelt-detail'>
            <div className='company__primary-info'>
              <h1>{company.name}</h1>
              <div className='company__description'>{company.offer.plain_description}</div>
              <div className='company__category'>
                <span className='company__category__label'>Kategorie: </span>
                <span className='company__category-item'>{company.offer.category.name}</span>
              </div>
            </div>
            <hr />
            <div className='company__secondary-info'>
              <div className='split-container'>
                <div className='split-container__element'>
                  <h2>Anbieter</h2>
                  <div className='company__logo__container'>
                    <div className='company__logo'>
                      <NextImage
                        src={addBaseUrl(company.logo.file.src)}
                        alt={company.logo.file.alt}
                        fill
                      />
                    </div>
                  </div>
                  <div className='company__address'>
                    <span className='company__name'>{company.name}</span>
                    <div className='company__details'>
                      {company.locations.map((location, index) => (
                        <div key={index}>
                          <div>
                            <span>{location?.street} · </span>
                            <span>{location?.postalCode} </span>
                            <span>{location?.city}</span>
                          </div>
                          <div>Tel.{location?.telephone}</div>
                        </div>
                      ))}
                      <a
                        href={company.website}
                        target='_blank'
                        title={`Webseite von ${company.name}`}
                        rel='noreferrer'
                      >
                        {company.website}
                      </a>
                    </div>
                  </div>
                </div>
                <div className='bonuswelt-map-container split-container__element'>
                  <h2>Karte</h2>
                  {company.locations.map((location, index) => (
                    <div key={index} className='bonuswelt-map'>
                      {/* TODO: remove iframe and use leaflet instead */}
                      {/*
                      <iframe
                        width='100%'
                        height='400px'
                        frameBorder='0'
                        scrolling='no'
                        marginHeight={0}
                        marginWidth={0}
                        src={`https://www.openstreetmap.org/export/embed.html?bbox=${location.longitude}%2C${location.latitude}&layer=mapnik&marker=${location.latitude}%2C${location.longitude}`}
                        style={{ border: '1px solid black' }}
                      />
                      */}
                      <small>
                        <a
                          href={`https://www.openstreetmap.org/#map=17/${location.latitude}/${location.longitude}&amp;layers=N`}
                        >
                          Größere Karte anzeigen
                        </a>
                      </small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className='bonuswelt-uebersicht-link'>
              <Link href='/bonuswelten' passHref className='button button--primary'>
                Zurück zu den Angeboten
              </Link>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}

export default BonusweltDetail;
